import r from "../node_modules/lodash/lodash.mjs";
const m = (o) => {
  const t = o.split("-");
  return t.length > 2 ? t.slice(0, -1).join("-") : t[0];
};
function g(o, t) {
  const c = r.groupBy(Object.entries(o), ([s]) => m(s));
  return r.mapValues(c, (s) => {
    var n, a;
    const i = ((n = s.find(([e]) => e.endsWith("-light"))) == null ? void 0 : n[1]) || {}, u = ((a = s.find(([e]) => e.endsWith("-dark"))) == null ? void 0 : a[1]) || {};
    return r.mapValues(i, (e, h) => {
      const l = u[h];
      return l ? { value: { base: `{colors.${e}}`, _dark: `{colors.${l}}` } } : { value: { base: `{colors.${e}}` } };
    });
  })[t];
}
export {
  g as buildThemeColors,
  m as getThemeName
};
